import * as React from 'react';
import { compose, pure } from 'recompose';
import { WrappedFieldInputProps } from 'redux-form';

import { Omit } from '@material-ui/core';
import MuiCheckbox, { CheckboxProps as CheckboxMUIProps } from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';

import { VTheme } from '@style/theme';

// import { transition } from '../../themeUtils';

export interface CheckboxProps extends CheckboxMUIProps {
  label?: string;
  input?: WrappedFieldInputProps;
  classes?: Partial<WithStyles<typeof styles>['classes']>;
  onChange?: (value: any) => void;
}

interface CheckboxPrivateProps extends WithStyles<typeof styles, true>, Omit<CheckboxProps, 'classes'> {}

const styles = (theme: VTheme) =>
  createStyles({
    default: {
      width: 'auto',
      height: 'auto',
      color: theme.palette.primary.dark,
      marginRight: 5,
      // transition: transition(50),
    },
    checked: {
      color: theme.palette.primary.light,
    },
    root: {
      margin: 0,
    },
  });

const Checkbox: React.FC<CheckboxPrivateProps> = (props) => {
  const { label, classes, input, ...others } = props;

  const checkBoxEl = (
    <MuiCheckbox
      color={'default'}
      className={classes.default}
      checked={input ? !!input.value : false}
      onChange={input && input.onChange}
      {...others}
    />
  );

  const checkboxElWithLabel = <FormControlLabel control={checkBoxEl} label={label} classes={{ root: classes.root }} />;

  return <div>{label ? checkboxElWithLabel : checkBoxEl}</div>;
};

const ComposedCheckbox = compose<CheckboxPrivateProps, CheckboxProps>(
  withStyles(styles, { withTheme: true }),
  pure,
)(Checkbox);

ComposedCheckbox.displayName = 'Checkbox';

export default ComposedCheckbox;
